import { rockyMountConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function RockyMountPage() {
  return <CityPageTemplate config={rockyMountConfig} />;
}